import { Container } from "@chakra-ui/react"
import { Section } from "../../components/Section"
import { DiscountsOverview } from "../../containers/supervizor/discounts/DiscountsOverview"

export const DiscountsOverviewPage = () => {
    return (
        <Section>
            <Container>
                <DiscountsOverview />
            </Container>
        </Section>
    )
}
